import DonateImg from "../../Images/Donate/Donate-Img-2.png";

const Donate = () => {
  return (
    <div className="relative h-96 lg:h-[24rem] text-white">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat brightness-75"
        style={{ backgroundImage: `url(${DonateImg})` }}
        role="img"
        aria-label="Donate background"
      ></div>

      {/* Text Overlay */}
      <div className="relative z-10 flex items-center justify-end h-full px-6 md:px-12">
        <div className="w-full md:w-1/2 lg:w-2/5 space-y-4">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold leading-tight tracking-wide drop-shadow-lg animate-fadeIn">
            Your Kindness Can Change Lives
          </h2>
          <p className="text-lg md:text-xl text-gray-100">
            Every donation helps us bring hope and support to those in need.
          </p>
          <button className="mt-4 text-ndlogoBlue inline-block bg-white text-blue-700 font-semibold px-6 py-3 rounded-lg shadow-lg hover:bg-blue-600  transition duration-300 ease-in-out">
            Donate Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default Donate;
